export default function () {
  return {
    warehouse: {},
    loading: false,
  }
}
